// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__XIdkj","errorLogs":"EditorFooter_errorLogs__3nATb"};